import styles from './DadosDoComprador.module.scss';
import { useEffect, useState } from "react";
import useFetchCompradores from "../../../hooks/compradores/useFetchCompradores";
import { IPedido } from "../../../interfaces/pedido.interface";
import { IComprador } from "../../../interfaces/comprador.interface";

export default function DadosDoComprador({ pedido }: { pedido: IPedido }) {
    const { compradores, loading, error } = useFetchCompradores();
    const [comprador, setComprador] = useState<IComprador | undefined>(undefined);

    useEffect(() => {
        setComprador(compradores.find((c) => c.id === pedido.compradorId));
    }, [compradores, pedido.compradorId]);

    if (loading) return <p>Carregando...</p>;
    if (error) return <p>Erro ao carregar dados do comprador.</p>;

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>DADOS DO COMPRADOR</h1>

            {comprador ? (
                <div className={styles.conteudo}>
                    <div className={styles.containerInputs}>
                        <div className={styles.inputHorizontal}>
                            <h4>Código: </h4>
                            <p>{comprador.id}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>Razão Social: </h4>
                            <p>{comprador.razaoSocial}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>CNPJ: </h4>
                            <p>{comprador.cnpj}</p>
                        </div>
                    </div>

                    <div className={styles.containerInputs}>
                        <div className={styles.inputHorizontal}>
                            <h4>Inscrição Estadual: </h4>
                            <p>{comprador.inscricaoEstadual}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>Insc. Mun.: </h4>
                            <p>{comprador.inscricaoMunicipal}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>Telefone: </h4>
                            <p>{comprador.telefone}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>Celular: </h4>
                            <p>{comprador.celular}</p>
                        </div>
                    </div>

                    <div className={styles.containerInputs}>
                        <div className={styles.inputHorizontal}>
                            <h4>Endereço: </h4>
                            <p>{comprador.endereco}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>CEP: </h4>
                            <p>{comprador.endereco}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>MUN./UF: </h4>
                            <p>{comprador.endereco}</p>
                        </div>
                    </div>

                    <div className={styles.containerInputs}>
                        <div className={styles.inputHorizontal}>
                            <h4>Email: </h4>
                            <p>{comprador.email}</p>
                        </div>

                        <div className={styles.inputHorizontal}>
                            <h4>OBS: </h4>
                            <p>{pedido.observacoes}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <p>Comprador não encontrado.</p>
            )}
        </div>
    );
}
